/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignatureSignerV1Dto = {
  /**
   * The id of the signer
   */
  id: string;
  /**
   * Signature signer status
   */
  status: SignatureSignerV1Dto.status;
};
export namespace SignatureSignerV1Dto {
  /**
   * Signature signer status
   */
  export enum status {
    ABORTED = 'aborted',
    CONSENT_GIVEN = 'consent_given',
    DECLINED = 'declined',
    ERROR = 'error',
    INITIATED = 'initiated',
    NOTIFIED = 'notified',
    PROCESSING = 'processing',
    SIGNED = 'signed',
    VERIFIED = 'verified',
  }
}
